import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Tab, Nav, Button, Dropdown, Col, Row, ListGroup } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import ReactFsLightbox from "fslightbox-react";
import { TbFileUpload } from "react-icons/tb";
import { FaFile } from "react-icons/fa";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { getQuickreplyAllData } from "../../../store/Quickreply/QuickreplyThunk";

//img

import user1 from "../../../assets/images/user/users.png";
// import user1 from "../../../assets/images/chat/avatar/01.png";
import user2 from "../../../assets/images/chat/avatar/02.png";
import user3 from "../../../assets/images/chat/avatar/03.png";
import user4 from "../../../assets/images/chat/avatar/04.png";
import user5 from "../../../assets/images/chat/avatar/05.png";
import user6 from "../../../assets/images/chat/avatar/06.png";
import user7 from "../../../assets/images/chat/avatar/07.png";
import user8 from "../../../assets/images/chat/avatar/08.png";
import user9 from "../../../assets/images/chat/avatar/09.png";

import user10 from "../../../assets/images/chat/avatar/10.png";
import chatImg from "../../../assets/images/chat/05.png";

//scrollbar
import Scrollbar from "smooth-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIgConversations,
  getIgConversationByUser,
} from "../../../store/instagram/instagramThunk";
import { uploadFileToCloudinary } from "../../../store/Cloudinary/CloudinaryThunk";
import {
  facebooksendmessage,
  FBautochat,
  fetchFBConversations,
  getFBConversationByUser,
} from "../../../store/facebook/facebookThunk";
import EmojiPicker from "emoji-picker-react";
import {
  fatchNewUser,
  fatchUser,
  fetchContacts,
  fetchConversationById,
  NewAsync,
  telegramSendmessages, tgRealTime, tgSendFile,
} from "../../../store/telegram/telegramThunk";
import { Hourglass } from "react-loader-spinner";

const TgChat = () => {
  const [chats, setChats] = useState(null);
  const [Showimg, setShowimg] = useState(null);
  const inputFile = useRef(null);

  const [currentChatId, setCurrentChatId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loginUserId, setLoginUserId] = useState(null);
  const [senderId, setSenderId] = useState();
  const [messages, setMessages] = useState([]);
  const [instagramAccountId, setInstagramAccountId] = useState();
  const [telegramAccountId, setTelegramAccountId] = useState();
  const [messageNavbar, setMessageNavbar] = useState(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [faqs, setFaqs] = useState(null);
  const [filteredQuickReplies, setFilteredQuickReplies] = useState(null);
  const [contactData, setContactData] = useState(null)
  const [loadingMessage, setLoadingMessage] = useState(false)
  console.log(contactData, "contactDatacontactDatacontactData")
  const { getQuickreplyLoding, getQuickreplyerrer, getQuickreplySuccess } =
    useSelector((state) => state.Quickreply);
  const [showquickreply, setShowQuickReply] = useState(false);

  console.log(messages, "---------------------------------------------");

  const [imageController, setImageController] = useState({
    toggler: false,
    slide: 1,
  });

  let handleQuickReplies = (payload) => {
    if (payload) {
      setNewMessage(payload);
      setShowQuickReply(false);
    }
  };

  const [image, setImage] = useState("");
  const [isSwitchOn, setIsSwitchOn] = useState();

  const [newMessage, setNewMessage] = useState("");

  const FsLightbox = ReactFsLightbox.default
    ? ReactFsLightbox.default
    : ReactFsLightbox;

  let dispatch = useDispatch();
  const sectionRef = useRef(null);

  const { conversations, loading, conversationDetails, message, error } = useSelector(
    (state) => state.facebook
  );


  const {
    fetchConversationFullfill,
    fetchConversationError,
    fetchContactsFullfill,
    fetchContactsError,
    fatchUserError,
    fatchUserFullfill,
    fatchNewUserFullfill,
    fatchNewUserloading,
    fatchUserloading,
    fetchConversationloading,
    tgSendFileloading
  } = useSelector((state) => state.telegram);
  console.log(fatchNewUserloading,"fatchNewUserloadingfatchNewUserloadingfatchNewUserloading")
  console.log(fetchContactsFullfill, "fetchContactsFullfillfetchContactsFullfillfetchContactsFullfill")
  console.log(fetchConversationFullfill, "fetchConversationFullfillfetchConversationFullfill")
  console.log(fatchUserFullfill, "fatchUserFullfillfatchUserFullfill")
  console.log(fatchUserError, "fatchUserErrorfatchUserErrorfatchUserError")
  console.log(fetchConversationError, "fetchConversationErrorfetchConversationErrorfetchConversationError")
  console.log(fetchContactsError, "fetchContactsErrorfetchContactsErrorfetchContactsError")


  // useEffect(() => {
  //     dispatch(fetchConversationById());
  // }, []);

  useEffect(() => {
    // dispatch(fatchNewUser())
    dispatch(fatchUser());
    dispatch(getQuickreplyAllData());
    dispatch(tgRealTime())
  }, []);

  useEffect(() => {
    dispatch(fetchContacts());
  }, []);

  useEffect(() => {
    if (sectionRef.current) {
      sectionRef.current.scrollTo(0, sectionRef.current.scrollHeight);
    }
  }, [messages, currentChatId]);

  useEffect(() => {
    // WebSocket connection
    const ws = new WebSocket("ws://localhost:8080");

    ws.onmessage = async (event) => {
      console.log(currentChatId, "currentChatIdcurrentChatId");
      const dataId = currentChatId;
      try {
        const message = JSON.parse(event.data);
        if (message.newConversation) {
          // Dispatch the action to fetch new user
          dispatch(fatchNewUser());
        }

        setMessages((prevMessages) => [...prevMessages, message]);
      } catch (error) {
        console.error("Error parsing message data", error);
      }
    };

    return () => {
      ws.close();
    };
  }, []);

  useEffect(() => {
    setFaqs(getQuickreplySuccess?.data);
  }, [getQuickreplySuccess]);


  useEffect(() => {
    // if (fetchContactsFullfill.length > 0) {
    setContactData(fetchContactsFullfill)
    // }
  }, [fetchContactsFullfill])

  useEffect(() => {
    setChats(fatchNewUserFullfill?.telegramUser);
  }, [fatchNewUserFullfill])
  // useEffect(() => {
  //     if (currentChatId) {
  //         setChats(conversations);
  //     }
  //     else {
  //         setChats(conversations);
  //         setCurrentChatId(conversations[0]?.id);
  //         dispatch(getFBConversationByUser(conversations[0]?.id));
  //         setSenderId(conversations[0]?.participants?.data[0]?.id);
  //         setMessageNavbar(conversations[0]);
  //         setIsSwitchOn(conversations[0]?.autochat);

  //     }
  // }, [dispatch, conversations]);

  // useEffect(() => {
  //     dispatch(fetchConversationById());
  // }, []);

  // useEffect(() => {
  //     getData()
  // }, [])

  // const getData = async () => {
  //     const res = await NewAsync()
  //     console.log(res, "res res res res res ")
  // }
  // useEffect(() => {
  //     setMessages(conversationDetails?.data);
  //     if (conversationDetails?.data) {
  //         const reversedData = [...conversationDetails.data].reverse(); // Create a reversed copy
  //         setMessages(reversedData); // Set messages with reversed data
  //     }
  //     console.log(conversationDetails?.recipient, "---id----");
  //     setInstagramAccountId(conversationDetails?.recipient);
  // }, [conversationDetails]);

  // useEffect(() => {
  //   Scrollbar.init(document.querySelector(".data-scrollbar"));
  // });

  // useEffect(() => {
  //     if (uploadedFile && uploadedFile.url) {
  //         // const data = {
  //         //   recipient: { id: senderId },
  //         //   message: {
  //         //     attachment: {
  //         //       type: "image",
  //         //       payload: {
  //         //         url: uploadedFile.url,
  //         //         is_reusable: true,
  //         //       },
  //         //     },
  //         //   },
  //         // };
  //         let fileType = uploadedFile?.filetype;
  //         if (fileType.startsWith("image/")) {
  //             console.log(fileType, "fileType imagwe ");
  //             const data = {
  //                 recipient: { id: senderId },
  //                 message: {
  //                     attachment: {
  //                         type: "image",
  //                         payload: {
  //                             url: uploadedFile.url,
  //                             is_reusable: true,
  //                         },
  //                     },
  //                 },
  //             };
  //             dispatch(facebooksendmessage(data));

  //         } else if (fileType.startsWith("application/")) {
  //             const data = {
  //                 recipient: { id: senderId },
  //                 message: {
  //                     attachment: {
  //                         type: "file",
  //                         payload: {
  //                             url: uploadedFile.url,
  //                             is_reusable: true,

  //                         }
  //                     },
  //                 },
  //             };
  //             dispatch(facebooksendmessage(data));
  //         } else if (fileType.startsWith("video/")) {
  //             const data = {
  //                 recipient: { id: senderId },
  //                 attachment: {
  //                     type: "video",
  //                     payload: {
  //                         url: uploadedFile.url,
  //                         is_reusable: true,
  //                     },
  //                 },
  //             };
  //             dispatch(facebooksendmessage(data));

  //         } else {
  //             alert("not support");
  //             console.log("Unsupported file type:", fileType);
  //         }// dispatch(facebooksendmessage(data))

  //     }
  // }, [uploadedFile]);

  let handleCopy = (message) => {
    navigator.clipboard.writeText(message);
  };

  const minisidebar = () => {
    const sidebar = document.getElementById("chatsidebar");
    if (sidebar) {
      sidebar.classList.toggle("sidebar-mini2");
    } else {
      console.error("Element with id 'sidebar' not found");
    }
  };

  useEffect(() => {
    setLoadingMessage(true)
    setMessages(fetchConversationFullfill?.conversation?.data);
    if (fetchConversationFullfill?.conversation?.data) {
      const reversedData = [
        ...fetchConversationFullfill?.conversation?.data,
      ].reverse();
      setMessages(reversedData);
    }
  }, [currentChatId, fetchConversationFullfill]);

  useEffect(() => {
    if (currentChatId) {
      dispatch(fetchConversationById(currentChatId));
      setChats(fatchUserFullfill?.telegramUser);
      // setLoginUserId(fatchUserFullfill?.telegramUser[0]?.telegramUserId)
    } else {
      const firstRecordData = fatchUserFullfill?.telegramUser;
      if (Array.isArray(firstRecordData) && firstRecordData.length > 0) {
        setCurrentChatId(firstRecordData[0]?.id);
      }
      // setCurrentChatId(fatchUserFullfill?.telegramUser)
      // setCurrentChatId(firstRecordData[0]?.id);
    }
  }, [dispatch, fatchUserFullfill]);


  const handleChatSelect = (item) => {
    setCurrentChatId(item?.id);
    dispatch(fetchConversationById(item?.id));
    // setMessageNavbar(item);
    // setIsSwitchOn(item?.autochat);
    // setSenderId(item?.participants?.data[0]?.id);
  };

  const handleSendMessage = async (e) => {
    // if (newMessage.trim() === "" || !senderId) return;

    try {
      const data = {
        userId: currentChatId,
        message: newMessage
      };

      console.log(data, "datadatadatadatadatadatadata")
      await dispatch(telegramSendmessages(data))
      setNewMessage("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const onButtonClick = () => {
    inputFile.current.click();
  };
  // console.log(fetchConversationFullfill.status, "fetchConversationFullfill.statusfetchConversationFullfill.status")

  console.log(messages, "----------------------------------------------------");
  const handleSwitchChange = async () => {
    let data = {
      currentChatId: currentChatId,
      autochat: !isSwitchOn,
    };
    let response = await dispatch(FBautochat(data));

    //  fetchConversations();

    dispatch(fetchFBConversations());
    await setIsSwitchOn(!isSwitchOn); // Toggle the switch state
  };

  <FsLightbox
    toggler={imageController.toggler}
    sources={[Showimg]}
  // slide={imageController.slide}
  />;

  // const handleFileUpload = async (e) => {
  //   const { files } = e.target;
  //   if (files && files.length) {
  //     if (files.length === 0) return;
  //     const file = files[0];
  //     const fileType = file.type;
  //     console.log(file, "filefilefile");
  //     console.log(fileType, "fileTypefileTypefileType");

  //     let documentUrl;
  //     let publicId;
  //     // var parts = filename.split(".");
  //     // const fileType = parts[parts.length - 1];
  //     const supportedImageTypes = ["jpg", "jpeg", "png", "gif", "bmp"];
  //     const supportedVideoTypes = ["mp4", "avi", "mov"];
  //     console.log("fileType", fileType); //ex: zip, rar, jpg, svg etc.
  //     const documentTypes = ["pdf", "doc", "docx", "xls", "xlsx"];
  //     if (
  //       supportedImageTypes.includes(fileType) === false ||
  //       supportedVideoTypes.includes(fileType) !== false
  //     ) {
  //       console.log(!supportedImageTypes.includes(fileType));
  //       alert(
  //         "Document files are not supported. Please upload an image or video."
  //       );
  //       return;
  //     }

  //     setImage(files[0]);
  //     dispatch(uploadFileToCloudinary(files[0]))
  //     // const documentUrl = await uploadImageToCloudinary(files[0]);
  //     // console.log(documentUrl, "filedatafiledatafiledata");

  //     // const igToken = Cookies.get("igToken");

  //   }
  // };

  const handleFileUpload = async (e) => {
    const { files } = e.target;

    console.log(files, "filesfiles");
    if (files.length === 0) return;

    const file = files[0];
    const fileType = file.type;
    console.log(file, "filefilefile");
    console.log(fileType, "fileTypefileTypefileType");

    const data = {
      userId: currentChatId,
      file: file
    };

    let documentUrl;
    let publicId;

    try {
      const response = await dispatch(tgSendFile(data));
      console.log(response, "responseresponse")
    } catch (error) {
      console.error("Error uploading file or sending to Facebook:", error);
    }
  };
  const handleEmojiClick = (emojiObject) => {
    setNewMessage((prevMessage) => prevMessage + emojiObject.emoji);
  };
  const filteredChats = chats?.filter(chat =>
    chat?.displayName
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
  const handleDocumentClick = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url || "file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  console.log(chats, "chatschatschatschatschatschatschatschatschats");

  return (
    <>
      {
        fatchNewUserloading ?
          <>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100vh" }}
            >
              <Hourglass
                visible={true}
                height="80"
                width="80"
                ariaLabel="hourglass-loading"
                colors={["#50b5ff", "#50b5ff"]}
              />
            </div>
          </> : <>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <aside
                className="sidebar sidebar-chat sidebar-base border-end shadow-none"
                data-sidebar="responsive"
                id="chatsidebar"
              >
                <div className="chat-search pt-4 px-4">
                  <div className="d-flex align-items-center">
                    <h5 className="fw-500">Chats</h5>
                  </div>
                  <div
                    className="sidebar-toggle d-block d-xl-none"
                    data-toggle="sidebar"
                    data-active="true"
                    onClick={minisidebar}
                  >
                    <i className="icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.25 12.2744L19.25 12.2744"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </i>
                  </div>
                  <div className="chat-searchbar mt-3 pt-1 mb-4">
                    <Form.Group className="form-group chat-search-data m-0">
                      <input
                        type="text"
                        className="form-control round"
                        id="chat-search"
                        placeholder="Search for messages or users..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <i className="material-symbols-outlined">search</i>
                    </Form.Group>
                  </div>
                </div>

                <div
                  className="sidebar-body pt-0 data-scrollbar  px-4"
                  tabIndex="-1"
                  style={{ overflow: "auto", outline: "none" }}
                >
                  <div
                    className="scroll-content"
                    style={{ transform: "translate3d(0px, 0px, 0px)" }}
                  >
                    <ul
                      className="nav navbar-nav iq-main-menu mb-5 pb-5"
                      id="sidebar-menu"
                      role="tablist"
                    >
                      <h6 className="mb-3 pb-1">Recent Chats</h6>
                      {filteredChats?.map((chat, index) => (
                        <Nav.Item
                          key={index}
                          as="li"
                          className="iq-chat-list mb-[1px]  ps-0"
                          role="presentation"
                        >
                          <Nav.Link
                            className={`d-flex gap-3 rounded-2 zoom-in ${currentChatId === chat?.id ? "active" : ""
                              }`}
                            eventKey="first"
                            onClick={() => handleChatSelect(chat)}
                          >
                            <div className="position-relative">
                              <img
                                src={user1 || "defaultProfilePic.jpg"}
                                alt="User Avatar"
                                className="avatar-48 object-cover rounded-circle"
                                loading="lazy"
                              />
                              {/* <div className="iq-profile-badge bg-success"></div> */}
                            </div>
                            <div className="d-flex align-items-top w-100 iq-userlist-data">
                              <div className="d-flex flex-grow-1 flex-column">
                                <div className="d-flex align-items-center gap-1">
                                  <h6 className="mb-0 iq-userlist-name font-size-14 fw-semibold text-ellipsis short-1 flex-grow-1">
                                    {chat?.displayName || "Unknown User"}
                                  </h6>
                                  {/* <span className="mb-0 font-size-12">03:20 PM</span> */}
                                </div>
                                {/* <div className="d-flex align-items-center gap-2">
                              <p className="text-ellipsis short-1 flex-grow-1 font-size-14 mb-0">
                              {chat?.last_message?.text || "No messages yet"}
                              </p>
                              <Dropdown className="btn-group dropdown-user">
                              <Dropdown.Toggle
                                  as="span"
                                  className="bg-transparent dropdown-toggle border-0 text-white"
                                  aria-expanded="false"
                              ></Dropdown.Toggle>
                              <Dropdown.Menu
                                  as="ul"
                                  className="dropdown-menu dropdown-menu-end p-0"
                              >
                                  <Dropdown.Item className="font-size-14 text-dark px-2">
                                  <span className="material-symbols-outlined mx-1 font-size-20 align-middle text-body">
                                      share
                                  </span>
                                  Share Contact
                                  </Dropdown.Item>
                                  <Dropdown.Item className="font-size-14 text-dark px-2">
                                  <span className="material-symbols-outlined mx-1 font-size-20 align-middle text-body">
                                      content_copy
                                  </span>
                                  Copy Contact
                                  </Dropdown.Item>
                              </Dropdown.Menu>
                              </Dropdown>
                          </div> */}
                              </div>
                            </div>
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                      <h6 className="mb-3 pb-1 mt-3">Your contact on telegram</h6>
                      {contactData?.map((chat, index) => (
                        <Nav.Item
                          key={index}
                          as="li"
                          className="iq-chat-list mb-[1px]  ps-0"
                          role="presentation"
                        >
                          <Nav.Link
                            className={`d-flex gap-3 rounded-2 zoom-in ${currentChatId === chat?.id ? "active" : ""
                              }`}
                            eventKey="first"
                            onClick={() => handleChatSelect(chat)}
                          >
                            <div className="position-relative">
                              <img
                                src={user1 || "defaultProfilePic.jpg"}
                                alt="User Avatar"
                                className="avatar-48 object-cover rounded-circle"
                                loading="lazy"
                              />
                              {/* <div className="iq-profile-badge bg-success"></div> */}
                            </div>
                            <div className="d-flex align-items-top w-100 iq-userlist-data">
                              <div className="d-flex flex-grow-1 flex-column">
                                <div className="d-flex align-items-center gap-1">
                                  <h6 className="mb-0 iq-userlist-name font-size-14 fw-semibold text-ellipsis short-1 flex-grow-1">
                                    {chat?.firstName}
                                  </h6>
                                  {/* <span className="mb-0 font-size-12">03:20 PM</span> */}
                                </div>
                              </div>
                            </div>
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </ul>
                  </div>
                  {/* <div
              className="scroll-content"
              style={{ transform: "translate3d(0px, 0px, 0px)" }}
            >
              <ul
                className="nav navbar-nav iq-main-menu mb-5 pb-5"
                id="sidebar-menu"
                role="tablist"
              >
                <h6 className="mb-3 pb-1">Your contact on telegram</h6>
              </ul>
            </div> */}
                </div>
                <div className="sidebar-footer"></div>
              </aside>
              <main className="main-content">
                <div className="container-fluid content-inner p-0" id="page_layout">
                  <Tab.Content id="myTabContent">
                    <Tab.Pane //1
                      eventKey="first"
                      className="card mb-0 fade position-relative"
                      id="user-content-101"
                      role="tabpanel"
                    >
                      <div className="chat-head position-absolute top-0 w-100 z-indexs chat-nav">
                        <header className="d-flex justify-content-between align-items-center pt-3 ps-3 pe-3 pb-3">
                          <div className="d-flex align-items-center gap-3">
                            <div className="d-block d-xl-none">
                              <button
                                className="btn btn-sm btn-primary rounded btn-icon"
                                data-toggle="sidebar"
                                data-active="true"
                                onClick={minisidebar}
                              >
                                <span className="btn-inner">
                                  <svg
                                    className="icon-rtl"
                                    width="20px"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                                    ></path>
                                  </svg>
                                </span>
                              </button>
                            </div>
                            <div className="avatar chat-user-profile m-0">
                              <img
                                src={user1}
                                alt="avatar"
                                className="avatar-50 object-cover rounded-pill"
                                loading="lazy"
                              />
                              {/* <div className="iq-profile-badge bg-success"></div> */}
                            </div>
                            <div>
                              <h5 className="mb-0">
                                {messageNavbar?.participants?.data[0]?.name}
                              </h5>
                              {/* <small className="text-capitalize fw-500">Online</small> */}
                            </div>
                          </div>

                          <div className="chat-header-icons d-inline-flex ms-auto">
                            <span className="w-100">Autochat</span>
                            <Form.Check
                              type="switch"
                              id="custom-switch"
                              className="me-2  bg-primary-subtle d-flex align-items-center justify-content-center"
                              checked={isSwitchOn} // Switch state is controlled
                              onChange={handleSwitchChange} // Handle switch toggle
                            />
                            {/* <Link
                            href="#"
                            className="chat-icon-phone bg-primary-subtle d-flex align-items-center justify-content-center"
                        >
                            <i className="material-symbols-outlined md-18">phone</i>
                        </Link>
                        <Link
                            href="#"
                            className="chat-icon-video bg-primary-subtle d-flex align-items-center justify-content-center"
                        >
                            <i className="material-symbols-outlined md-18">
                            videocam
                            </i>
                        </Link>
                        <Link
                            href="#"
                            className="chat-icon-delete bg-primary-subtle d-flex align-items-center justify-content-center"
                        >
                            <i className="material-symbols-outlined md-18">
                            delete
                            </i>
                        </Link> */}
                            <Dropdown
                              className="bg-primary-subtle d-flex align-items-center justify-content-center"
                              as="span"
                            >
                              <Dropdown.Toggle
                                as="svg"
                                bsPrefix=" "
                                className="icon-20 nav-hide-arrow cursor-pointer pe-0"
                                id="dropdownMenuButton-09"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                role="menu"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10 20.6788C10 21.9595 11.0378 23 12.3113 23C13.5868 23 14.6265 21.9595 14.6265 20.6788C14.6265 19.3981 13.5868 18.3576 12.3113 18.3576C11.0378 18.3576 10 19.3981 10 20.6788ZM10 12.0005C10 13.2812 11.0378 14.3217 12.3113 14.3217C13.5868 14.3217 14.6265 13.2812 14.6265 12.0005C14.6265 10.7198 13.5868 9.67929 12.3113 9.67929C11.0378 9.67929 10 10.7198 10 12.0005ZM12.3113 5.64239C11.0378 5.64239 10 4.60192 10 3.3212C10 2.04047 11.0378 1 12.3113 1C13.5868 1 14.6265 2.04047 14.6265 3.3212C14.6265 4.60192 13.5868 5.64239 12.3113 5.64239Z"
                                  fill="currentColor"
                                ></path>
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                className="dropdown-menu-right"
                                aria-labelledby="dropdownMenuButton-09"
                              >
                                <Dropdown.Item
                                  className=" d-flex align-items-center"
                                  href="#"
                                >
                                  <i className="material-symbols-outlined md-18 me-1">
                                    push_pin
                                  </i>
                                  Pin to top
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className=" d-flex align-items-center"
                                  href="#"
                                >
                                  <i className="material-symbols-outlined md-18 me-1">
                                    delete_outline
                                  </i>
                                  Delete chat
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className=" d-flex align-items-center"
                                  href="#"
                                >
                                  <i className="material-symbols-outlined md-18 me-1">
                                    watch_later
                                  </i>
                                  Block
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </header>
                      </div>
                      <div className="card-body chat-body bg-body" ref={sectionRef}>
                        {/* {
                    loadingMessage ?
                      <>
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: "100vh" }}
                        >
                          <Hourglass
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="hourglass-loading"
                            colors={["#50b5ff", "#50b5ff"]}
                          />
                        </div> </> : <>
                      </>
                  } */}
                        {messages?.map((msg, index) => {
                          const messageDate = new Date(msg.created_time);
                          const formattedTime = messageDate.toLocaleTimeString(
                            "en-US",
                            { hour: "2-digit", minute: "2-digit" }
                          );
                          const formattedDate = messageDate.toLocaleDateString(
                            "en-US",
                            { year: "numeric", month: "short", day: "numeric" }
                          );
                          const showDate =
                            index === 0 ||
                            new Date(
                              messages[index - 1]?.created_time
                            ).toDateString() !== messageDate.toDateString();

                          const hasAudioUrl = msg?.attachments?.data?.[0]?.audio_data;

                          const hasImage = msg.type === "image";
                          const hasDocumentUrl = msg.type === "pdf";
                          const hasVideo = msg.type === "video";




                          if (msg?.senderId !== currentChatId) {
                            return (
                              <React.Fragment key={msg.id}>
                                {showDate && (
                                  <div className="chat-day-title">
                                    <span className="main-title">
                                      {formattedDate}
                                    </span>
                                  </div>
                                )}
                                <div className="iq-message-body iq-current-user">
                                  <div className="chat-profile text-center">
                                    <img
                                      src={user1}
                                      alt="chat-user"
                                      className="avatar-40 object-cover rounded-pill"
                                      loading="lazy"
                                    />
                                    <small className="iq-chating p-0 mb-0 d-block">
                                      {formattedTime}
                                    </small>
                                  </div>
                                  <div className="iq-chat-text">
                                    <div className="d-flex align-items-center justify-content-end gap-1 gap-md-2">
                                      <Dropdown
                                        className="dropdown cursor-pointer more"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-original-title="More"
                                      >
                                        <Dropdown.Toggle
                                          className="lh-1"
                                          id="post-option"
                                          data-bs-toggle="dropdown"
                                          as="span"
                                          bsPrefix=" "
                                        >
                                          <span className="material-symbols-outlined text-dark">
                                            more_vert
                                          </span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu
                                          className="dropdown-menu dropdown-menu-right"
                                          aria-labelledby="post-option"
                                        >
                                          {msg?.message ? (
                                            <Dropdown.Item
                                              className=""
                                              href="#"
                                              data-bs-toggle="modal"
                                              data-bs-target="#post-modal"
                                              onClick={() => handleCopy(msg?.message)}
                                            >
                                              <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                                content_copy
                                              </span>
                                              Copy message text
                                            </Dropdown.Item>
                                          ) : null}
                                          <Dropdown.Item
                                            className=""
                                            href="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#post-modal"
                                          >
                                            <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                              edit
                                            </span>
                                            Edit
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                      <div
                                        className={
                                          hasImage
                                            ? `d-flex align-items-center`
                                            : `iq-chating-content d-flex align-items-center`
                                        }
                                      >
                                        {hasImage ? (
                                          // <div>
                                          //   {hasImage ? (
                                          //     <img
                                          //       src={hasImage}
                                          //       alt="Image attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : sharesimg ? (
                                          //     <img
                                          //       src={sharesimg}
                                          //       alt="Shared attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : (
                                          //     <iframe
                                          //       title="myFrame"
                                          //       className="rounded embed-responsive-item"
                                          //       src={hasvideo}
                                          //       allowFullScreen
                                          //     ></iframe>
                                          //   )}
                                          // </div>
                                          <div>
                                            <img
                                              src={msg?.mediaUrl}
                                              alt="Image attachment"
                                              style={{
                                                maxWidth: "200px",
                                                objectFit: "cover",
                                                borderRadius: "5px",
                                              }}
                                            />
                                          </div>
                                        ) : hasDocumentUrl ? (
                                          // <div>
                                          //   {hasImage ? (
                                          //     <img
                                          //       src={hasImage}
                                          //       alt="Image attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : sharesimg ? (
                                          //     <img
                                          //       src={sharesimg}
                                          //       alt="Shared attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : (
                                          //     <iframe
                                          //       title="myFrame"
                                          //       className="rounded embed-responsive-item"
                                          //       src={hasvideo}
                                          //       allowFullScreen
                                          //     ></iframe>
                                          //   )}
                                          // </div>

                                          <div>
                                            <div className="bg-secondary p-2 text-white">
                                              <div
                                                className="d-flex align-items-center"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDocumentClick(msg.mediaUrl)
                                                }
                                              >
                                                <span className="me-2">
                                                  <FaFile />
                                                </span>
                                                <span>
                                                  {msg.docName
                                                    ? msg.docName
                                                    : "Download"}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        ) : hasVideo ? (
                                          // <div>
                                          //   {hasImage ? (
                                          //     <img
                                          //       src={hasImage}
                                          //       alt="Image attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : sharesimg ? (
                                          //     <img
                                          //       src={sharesimg}
                                          //       alt="Shared attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : (
                                          //     <iframe
                                          //       title="myFrame"
                                          //       className="rounded embed-responsive-item"
                                          //       src={hasvideo}
                                          //       allowFullScreen
                                          //     ></iframe>
                                          //   )}
                                          // </div>

                                          <div>
                                            {/* <iframe
                                                                                title="myFrame"
                                                                                className="rounded embed-responsive-item"
                                                                                src={msg?.mediaUrl}
                                                                                allowFullScreen
                                                                            ></iframe> */}
                                            <video width="400" controls>
                                              <source src={msg?.mediaUrl} type="video/mp4" />
                                            </video>
                                          </div>
                                        ) : (
                                          <p className="mr-2 mb-0">{msg?.text}</p>
                                        )}
                                        {/* <p className="mr-2 mb-0">{msg?.text}</p> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          } else {
                            return (
                              <React.Fragment key={msg.id}>
                                {showDate && (
                                  <div className="chat-day-title">
                                    <span className="main-title">
                                      {formattedDate}
                                    </span>
                                  </div>
                                )}
                                <div className="iq-message-body iq-other-user">
                                  <div className="chat-profile text-center">
                                    <img
                                      src={user1}
                                      alt="chat-user"
                                      className="avatar-40 object-cover rounded-pill"
                                      loading="lazy"
                                    />
                                    <small className="iq-chating p-0 mb-0 d-block">
                                      {formattedTime}
                                    </small>
                                  </div>
                                  <div className="iq-chat-text">
                                    <div className="d-flex align-items-center justify-content-start gap-md-2">
                                      <div
                                        className={
                                          hasImage
                                            ? `d-flex align-items-center`
                                            : `iq-chating-content d-flex align-items-center`
                                        }
                                      >
                                        {hasImage ? (
                                          // <div>
                                          //   {hasImage ? (
                                          //     <img
                                          //       src={hasImage}
                                          //       alt="Image attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : sharesimg ? (
                                          //     <img
                                          //       src={sharesimg}
                                          //       alt="Shared attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : (
                                          //     <iframe
                                          //       title="myFrame"
                                          //       className="rounded embed-responsive-item"
                                          //       src={hasvideo}
                                          //       allowFullScreen
                                          //     ></iframe>
                                          //   )}
                                          // </div>
                                          <div>
                                            <img
                                              src={msg?.mediaUrl}
                                              alt="Image attachment"
                                              style={{
                                                maxWidth: "200px",
                                                objectFit: "cover",
                                                borderRadius: "5px",
                                              }}
                                            />
                                          </div>
                                        ) : hasDocumentUrl ? (
                                          // <div>
                                          //   {hasImage ? (
                                          //     <img
                                          //       src={hasImage}
                                          //       alt="Image attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : sharesimg ? (
                                          //     <img
                                          //       src={sharesimg}
                                          //       alt="Shared attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : (
                                          //     <iframe
                                          //       title="myFrame"
                                          //       className="rounded embed-responsive-item"
                                          //       src={hasvideo}
                                          //       allowFullScreen
                                          //     ></iframe>
                                          //   )}
                                          // </div>

                                          <div>
                                            <div className="bg-secondary p-2 text-white">
                                              <div
                                                className="d-flex align-items-center"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleDocumentClick(msg.mediaUrl)
                                                }
                                              >
                                                <span className="me-2">
                                                  <FaFile />
                                                </span>
                                                <span>
                                                  {msg.docName
                                                    ? msg.docName
                                                    : "Download"}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        ) : hasVideo ? (
                                          // <div>
                                          //   {hasImage ? (
                                          //     <img
                                          //       src={hasImage}
                                          //       alt="Image attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : sharesimg ? (
                                          //     <img
                                          //       src={sharesimg}
                                          //       alt="Shared attachment"
                                          //       style={{
                                          //         maxWidth: "200px",
                                          //         objectFit: "cover",
                                          //         borderRadius: "5px",
                                          //       }}
                                          //     />
                                          //   ) : (
                                          //     <iframe
                                          //       title="myFrame"
                                          //       className="rounded embed-responsive-item"
                                          //       src={hasvideo}
                                          //       allowFullScreen
                                          //     ></iframe>
                                          //   )}
                                          // </div>

                                          <div>
                                            {/* <iframe
                                                title="myFrame"
                                                className="rounded embed-responsive-item"
                                                src={msg?.mediaUrl}
                                                allowFullScreen
                                            ></iframe> */}
                                            <video width="400" controls>
                                              <source src={msg?.mediaUrl} type="video/mp4" />
                                            </video>
                                          </div>
                                        ) : (
                                          <p className="mr-2 mb-0">{msg?.text}</p>
                                        )}
                                        {/* <p className="mr-2 mb-0">{msg?.text}</p> */}
                                      </div>
                                      <Link
                                        href="#"
                                        className="material-symbols-outlined font-size-20 text-dark reply"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-original-title="Reply"
                                      >
                                        reply
                                      </Link>
                                      <Dropdown
                                        className="dropdown cursor-pointer more"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-original-title="More"
                                      >
                                        <Dropdown.Toggle
                                          as="span"
                                          bsPrefix=" "
                                          className="lh-1"
                                          id="post-option"
                                          data-bs-toggle="dropdown"
                                        >
                                          <span className="material-symbols-outlined text-dark">
                                            more_vert
                                          </span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu
                                          as="ul"
                                          className="dropdown-menu dropdown-menu-right"
                                          aria-labelledby="post-option"
                                        >
                                          {msg?.message ? (
                                            <Dropdown.Item
                                              className=""
                                              href="#"
                                              data-bs-toggle="modal"
                                              data-bs-target="#post-modal"
                                              onClick={() => handleCopy(msg?.message)}
                                            >
                                              <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                                content_copy
                                              </span>
                                              Copy message text
                                            </Dropdown.Item>
                                          ) : null}
                                          <Dropdown.Item
                                            className=""
                                            href="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#post-modal"
                                          >
                                            <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                              edit
                                            </span>
                                            Edit
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          }
                        })}
                      </div>
                      {showEmojiPicker && (
                        <div className="position-absolute left-0 emoji-box">
                          <EmojiPicker onEmojiClick={handleEmojiClick} />
                        </div>
                      )}
                      {showquickreply && (
                        <div
                          className="position-absolute emoji-box"
                          style={{
                            left: "0",
                            bottom: "60px",
                            backgroundColor: "white",
                            color: "#fff",
                            width: "100%",
                            maxWidth: "350px",
                            borderRadius: "10px",
                            padding: "20px 10px",
                            boxShadow: "rgb(215 215 215 / 50%) 0px 2",
                            zIndex: 1000,
                          }}
                        >
                          <Row className="mb-2 px-2">
                            <Col>
                              <span
                                className="text-black"
                                style={{ fontSize: "1rem" }}
                              >
                                Quick Replies
                              </span>
                            </Col>
                          </Row>

                          <ListGroup variant="flush">
                            {filteredQuickReplies?.map((item, index) => (
                              <ListGroup.Item
                                key={index}
                                className="bg-transparent text-light border-0 py-2 border-bottom"
                                onClick={() => handleQuickReplies(item.payload)}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    <span
                                      className="text-black"
                                      style={{ fontSize: "0.85rem" }}
                                    >
                                      {item.title}
                                    </span>
                                    <br />
                                    <span
                                      className="text-[#a7a7a7]"
                                      style={{ fontSize: "0.95rem" }}
                                    >
                                      {item.payload || "No Title"}
                                    </span>
                                  </div>
                                </div>
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                        </div>
                      )}
                      <div className="card-footer px-3 py-3 border-top rounded-0">
                        <form className="d-flex align-items-center" action="#">
                          <div className="chat-attagement d-flex">
                            <Link
                              to="#"
                              className="d-flex align-items-center pe-3"
                              onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                            >
                              <svg
                                className="icon-24"
                                width="24"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_156_599)">
                                  <path
                                    d="M20.4853 4.01473C18.2188 1.74823 15.2053 0.5 12 0.5C8.79469 0.5 5.78119 1.74823 3.51473 4.01473C1.24819 6.28119 0 9.29469 0 12.5C0 15.7053 1.24819 18.7188 3.51473 20.9853C5.78119 23.2518 8.79469 24.5 12 24.5C15.2053 24.5 18.2188 23.2518 20.4853 20.9853C22.7518 18.7188 24 15.7053 24 12.5C24 9.29469 22.7518 6.28119 20.4853 4.01473ZM12 23.0714C6.17091 23.0714 1.42856 18.3291 1.42856 12.5C1.42856 6.67091 6.17091 1.92856 12 1.92856C17.8291 1.92856 22.5714 6.67091 22.5714 12.5C22.5714 18.3291 17.8291 23.0714 12 23.0714Z"
                                    fill="currentcolor"
                                  ></path>
                                  <path
                                    d="M9.40398 9.3309C8.23431 8.16114 6.33104 8.16123 5.16136 9.3309C4.88241 9.60981 4.88241 10.0621 5.16136 10.3411C5.44036 10.62 5.89266 10.62 6.17157 10.3411C6.78432 9.72836 7.78126 9.7284 8.39392 10.3411C8.53342 10.4806 8.71618 10.5503 8.89895 10.5503C9.08171 10.5503 9.26457 10.4806 9.40398 10.3411C9.68293 10.0621 9.68293 9.60986 9.40398 9.3309Z"
                                    fill="currentcolor"
                                  ></path>
                                  <path
                                    d="M18.8384 9.3309C17.6688 8.16123 15.7655 8.16114 14.5958 9.3309C14.3169 9.60981 14.3169 10.0621 14.5958 10.3411C14.8748 10.62 15.3271 10.62 15.606 10.3411C16.2187 9.72836 17.2156 9.72831 17.8284 10.3411C17.9679 10.4806 18.1506 10.5503 18.3334 10.5503C18.5162 10.5503 18.699 10.4806 18.8384 10.3411C19.1174 10.0621 19.1174 9.60986 18.8384 9.3309Z"
                                    fill="currentcolor"
                                  ></path>
                                  <path
                                    d="M18.3335 13.024H5.6668C5.2723 13.024 4.95251 13.3438 4.95251 13.7383C4.95251 17.6243 8.11409 20.7859 12.0001 20.7859C15.8862 20.7859 19.0477 17.6243 19.0477 13.7383C19.0477 13.3438 18.728 13.024 18.3335 13.024ZM12.0001 19.3573C9.14366 19.3573 6.77816 17.215 6.42626 14.4525H17.574C17.2221 17.215 14.8566 19.3573 12.0001 19.3573Z"
                                    fill="currentcolor"
                                  ></path>
                                </g>
                                <defs>
                                  <clipPath>
                                    <rect
                                      width="24"
                                      height="24"
                                      fill="white"
                                      transform="translate(0 0.5)"
                                    ></rect>
                                  </clipPath>
                                </defs>
                              </svg>
                            </Link>
                            <Link className="d-flex align-items-center pe-3">
                              {/* <svg
                          className="icon-24"
                          width="18"
                          height="23"
                          viewBox="0 0 18 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.00021 21.5V18.3391"
                            stroke="currentcolor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.00021 14.3481V14.3481C6.75611 14.3481 4.9384 12.5218 4.9384 10.2682V5.58095C4.9384 3.32732 6.75611 1.5 9.00021 1.5C11.2433 1.5 13.061 3.32732 13.061 5.58095V10.2682C13.061 12.5218 11.2433 14.3481 9.00021 14.3481Z"
                            stroke="currentcolor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                          <path
                            d="M17 10.3006C17 14.7394 13.418 18.3383 9 18.3383C4.58093 18.3383 1 14.7394 1 10.3006"
                            stroke="currentcolor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                          <path
                            d="M11.0689 6.25579H13.0585"
                            stroke="currentcolor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                          <path
                            d="M10.0704 9.59344H13.0605"
                            stroke="currentcolor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg> */}
                              <TbFileUpload style={{ fontSize: "25px" }} onClick={() => onButtonClick()} />
                            </Link>
                            <input
                              style={{ display: "none" }}
                              // accept=".zip,.rar"
                              ref={inputFile}
                              onChange={handleFileUpload}
                              type="file"
                            />
                          </div>
                          <input
                            type="text"
                            onChange={async (e) => {
                              const value = e.target.value;
                              setNewMessage(value);

                              if (e.target.value.startsWith("/")) {
                                setShowQuickReply(true);
                                const filterText = value.slice(1);
                                const filteredReplies =
                                  filterText.length > 0
                                    ? faqs?.filter((faq) =>
                                      faq?.title
                                        ?.toLowerCase()
                                        .includes(filterText.toLowerCase())
                                    )
                                    : faqs;

                                setFilteredQuickReplies(filteredReplies);
                              } else {
                                setShowQuickReply(false);
                              }
                            }}
                            className="form-control me-3"
                            value={newMessage}
                            placeholder="Type your message"
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleSendMessage();
                                setNewMessage("");
                              }
                            }}
                          />
                          <button
                            type="submit"
                            className="btn btn-primary d-flex align-items-center"
                          >
                            <svg
                              className="icon-20"
                              width="18"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.8325 6.67463L8.10904 12.4592L1.59944 8.38767C0.66675 7.80414 0.860765 6.38744 1.91572 6.07893L17.3712 1.55277C18.3373 1.26963 19.2326 2.17283 18.9456 3.142L14.3731 18.5868C14.0598 19.6432 12.6512 19.832 12.0732 18.8953L8.10601 12.4602"
                                stroke="currentcolor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                            <span
                              className="d-none d-lg-block ms-1"
                              onClick={() => handleSendMessage()}
                            >
                              Send
                            </span>
                          </button>
                        </form>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </main>
            </Tab.Container>
          </>
      }
    </>
  );
};
export default TgChat;
